export default "__VITE_ASSET__Iq6QMQ0u__"